export let itemListProps = {
    selected: false,
    key: 0,
    sl_no: 0,
    id: 0,

    tailoring_item_id: 0,
    size_id: 0,
    tailoring_detail: null,
    tailoring_qty: 1,
    is_combination_tailoring_item: false,
    combination_item_list: [],
    tailoring_trial_required: false,
    fabric_id: 0,
    fabric_detail: null,
    fabric_unit_qty: 0,
    sale_category_id: 0,
    wo_processing: false,
    work_order: [],
    work_order_id: 0,
    
    retail_item_id: 0,
    retail_detail: null,
    retail_qty: 1,
    
    tailoring_unit_rate: 0,
    tailoring_unit_discount_amount: 0,
    extra_charge_unit_rate: 0,
    extra_charge_unit_discount_amount: 0,
    extra_charge_description: '',
    fabric_unit_rate: 0,
    fabric_actual_rate: 0,
    fabric_price_fixed: false,
    fabric_unit_discount_amount: 0,
    
    retail_unit_rate: 0,
    retail_unit_discount_amount: 0,

    purchase_request_id: 0,
    purchase_request_qty: 0,
    purchase_request_description: '',

    sub_total: 0,

    discount_percent: 0,
    discount_amount: 0,

    taxable_total: 0,

    show_item_breakup_in_invoice: false,
    tailoring_tax_percent: 0,
    fabric_tax_percent: 0,
    tailoring_tax_amount: 0,
    fabric_tax_amount: 0,
    
    tax_percent: 0,
    tax_amount: 0,
    net_total: 0,

    alter_net_total: 0,
    is_cancelled: 0,
    extra_amount: 0,
    extra_amount_reason: '',

    store_id: 0,
    notes: '',

    canceled_sale_id: 0

}

export let dataProps = {
    id: 0,
    walk_in_customer: false,
    sale_type: 0, //estimate, order, invoice, mo
    mo_type: 0,
    sale_number: null,
    external_number: '',

    sale_date: new Date(),
    delivery_date: new Date(),
    trial_required: false,
    trial_date: "",

    customer_id: null, 
    paying_customer_id: null,
    paying_customer_detail: {id: 0, customer_name: '', profile_photo: ''},
    sale_person_staff_id: null, 
    store_id: null,
    
    additional_notes: '',
    total_qty: 0,
    sub_total: 0,
    discount_percent: 0,
    discount_amount: 0,
    taxable_total: 0,
    
    gst_type: 0,//cgst + sgst or igst
    tax_id: 0,
    tax_detail: null,

    total_tax: 0,
    shipping_and_handling: 0,
    adjustment: 0,
    net_total: 0, 

    total_paid: 0,
    sale_status: 0,
    balance: 0,

    advance_amount: 0,
    advance_payment_mode_id: null,
    tender_amount: 0,

    discount_coupon_id: 0,
    discount_coupon_code: '',
    discount_coupon_percent: 0,
    discount_coupon_fixed_amount: 0,
    billing_currency_id: null,
    exchange_rate: 0,
    invoice_ids: [],
    round_off: false,
    e_cart_id: 0,
    delivery_mode_id: null,

    cancel_original_sale_ref_id: 0,
    
    item_list_loading: false,

    tag_list: [],
    item_list: [],
    deleted_item_list: []
}


// WEBPACK FOOTER //
// ./src/store/modules/saleMaster/properties.js